"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var dialogPortal_1 = require("spry-react/DialogPortal/dialogPortal");
var transitionGroup_1 = require("spry-react/Animation/transitionGroup");
var animation_1 = require("spry-react/Animation/animation");
var idGenerator_1 = require("spry-react/utils/idGenerator");
var es6_promise_1 = require("es6-promise");
var confirmation_1 = require("spry-react/Confirmation/confirmation");
var arrayExtensions_1 = require("spry-react/utils/arrayExtensions");
var contextMenuContainer_1 = require("spry-react/ContextMenu/contextMenuContainer");
var serialOperation_1 = require("spry-react/SerialOperation/serialOperation");
var setWindowLocationHref_1 = require("spry-react/SerialOperation/setWindowLocationHref");
var _ = require("underscore");
var transparentCover_1 = require("spry-react/LoadingCover/transparentCover");
function isRelativePosition(position) {
    return position.relativeElementId !== undefined;
}
exports.isRelativePosition = isRelativePosition;
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.contextMenuElement = null;
        _this.beforeUnloadCallbacks = [];
        _this.animatingOpenDialogs = [];
        _this.openDialog = function (render) {
            _this.setState(function (prevState) {
                var prevDialogs = prevState.openDialogs;
                var updatedDialogs = arrayExtensions_1.clone(prevDialogs);
                var newDialogKey = "dialog-" + idGenerator_1.GenerateId();
                updatedDialogs.push({
                    key: newDialogKey,
                    render: render,
                    top: window.pageYOffset,
                    zIndex: Pb.ZIndexer.hasZIndexes() ? Pb.ZIndexer.getNext() : null
                });
                _this.animatingOpenDialogs.push(newDialogKey);
                return { openDialogs: updatedDialogs };
            });
        };
        _this.closeDialog = function (dialog) {
            _this.setState(function (prevState) {
                var updatedDialogs = arrayExtensions_1.remove(prevState.openDialogs, dialog);
                if (dialog.zIndex)
                    dialog.zIndex.dispose();
                return { openDialogs: updatedDialogs };
            });
        };
        _this.onDialogWillEnter = function (dialog) {
            return { visibility: "hidden" };
        };
        _this.onDialogDidEnter = function (dialog, element) {
            var top = window.pageYOffset; // note: must use pageYOffset not scrollY for IE
            return { position: "relative", top: new animation_1.DurationAnimationDefinition(top - element.clientHeight, top, 400, animation_1.Easing.CubicOut) };
        };
        _this.onDialogDoneEntering = function (dialog, element) {
            _this.animatingOpenDialogs = arrayExtensions_1.removeIfPresent(_this.animatingOpenDialogs, dialog.key);
        };
        _this.onDialogWillExit = function (dialog, element) {
            var top = element.clientTop;
            return { position: "relative", top: new animation_1.DurationAnimationDefinition(top, top - element.clientHeight, 400, animation_1.Easing.CubicOut) };
        };
        _this.renderDialog = function (dialog, currentStyle, childRef) {
            var renderedDialog = dialog.render(function () { return _this.closeDialog(dialog); });
            var isSecondaryDialog = _this.state.openDialogs.indexOf(dialog) > 0 || (Pb.ZIndexer.hasZIndexes() && _this.hasZIndex(dialog.zIndex));
            var isTopmostDialog = _this.hasOpenZIndexedDialogs()
                ? _this.hasZIndex(dialog.zIndex) && dialog.zIndex.zIndex === _this.getHighestZIndex()
                : dialog === _this.state.openDialogs[_this.state.openDialogs.length - 1];
            var topWhenDialogEntered = currentStyle.top, style = __rest(currentStyle, ["top"]);
            var effectiveTop = topWhenDialogEntered > dialog.top ? dialog.top : topWhenDialogEntered;
            var partialCoverZIndex = _this.hasZIndex(dialog.zIndex) ? dialog.zIndex.zIndex : 1000; //note: the z-index of 1000 is needed because the l-dialog class sets the z-index on dialogs
            var dialogPositionStyle = _this.hasZIndex(dialog.zIndex)
                ? { position: "absolute", width: "100%", zIndex: dialog.zIndex.zIndex }
                : { position: "absolute", width: "100%" };
            var isDialogAnimating = !!(arrayExtensions_1.find(_this.animatingOpenDialogs, function (key) { return key === dialog.key; }) || !arrayExtensions_1.find(_this.state.openDialogs, function (d) { return d.key === dialog.key; }));
            return renderedDialog
                ? React.createElement(dialogPortal_1.DialogPortal, { key: dialog.key },
                    isTopmostDialog
                        ? React.createElement("div", { id: "partial-cover", style: { display: "block", zIndex: partialCoverZIndex } })
                        : null,
                    React.createElement("div", { style: __assign(__assign({}, style), { top: effectiveTop }), className: isSecondaryDialog ? "secondary-dialog-container" : "" },
                        React.createElement("div", { style: dialogPositionStyle, ref: childRef },
                            React.createElement(transparentCover_1.TransparentCover, { active: isDialogAnimating, zIndex: partialCoverZIndex + 1 }),
                            renderedDialog)))
                : null;
        };
        _this.hasOpenZIndexedDialogs = function () {
            return Pb.ZIndexer.hasZIndexes() && _.any(_this.state.openDialogs, function (openDialog) { return _this.hasZIndex(openDialog.zIndex); });
        };
        _this.getHighestZIndex = function () {
            var maxZIndex = _this.state.openDialogs.length > 0
                ? _.max(_this.state.openDialogs, function (openDialog) { return _this.hasZIndex(openDialog.zIndex) ? openDialog.zIndex.zIndex : 0; }).zIndex
                : null;
            return maxZIndex != null
                ? maxZIndex.zIndex
                : null;
        };
        _this.registerContextMenu = function (render) {
            var openContextMenu = function (data, position, contextMenuClosedCallback) {
                if (_this.contextMenuElement) {
                    _this.closeContextMenu();
                }
                var key = isRelativePosition(position)
                    ? "contextMenu-" + position.relativeElementId
                    : "contextMenu-" + position.x + "-" + position.y;
                _this.setState({
                    currentContextMenu: { key: key, data: data, position: position, render: render, childRef: _this.setContextMenuRef, contextMenuClosedCallback: contextMenuClosedCallback }
                });
            };
            return openContextMenu;
        };
        _this.onContextMenuWillEnter = function (contextMenu) {
            return { visibility: "hidden" };
        };
        _this.onContextMenuDidEnter = function (contextMenu, element) {
            return { overflow: "hidden", height: new animation_1.DurationAnimationDefinition(0, element.clientHeight, 400, animation_1.Easing.CubicOut) };
        };
        _this.onContextMenuDoneEntering = function (contextMenu, element) {
            return { height: null };
        };
        _this.onContextMenuWillExit = function (contextMenu, element) {
            /* if there is a new context menu open, instantly close the previous one, otherwise animate the exit */
            return _this.state.currentContextMenu
                ? {}
                : { overflow: "hidden", height: new animation_1.DurationAnimationDefinition(element.clientHeight, 0, 200, animation_1.Easing.CubicIn) };
        };
        _this.setContextMenuRef = function (node) {
            _this.contextMenuElement = node;
        };
        _this.renderContextMenu = function (contextMenu, currentStyle, childRef) {
            return React.createElement(contextMenuContainer_1.ContextMenuContainer, { key: contextMenu.key, contextMenu: contextMenu, childRef: childRef, currentStyle: currentStyle, closeContextMenu: function () { return _this.closeContextMenu(); } });
        };
        _this.onClick = function (event) {
            if (_this.contextMenuElement) {
                _this.closeContextMenu();
            }
        };
        _this.closeContextMenu = function () {
            var _a;
            var closeContextMenuCallback = (_a = _this.state.currentContextMenu) === null || _a === void 0 ? void 0 : _a.contextMenuClosedCallback;
            _this.setState({ currentContextMenu: null }, function () { var _a; return (_a = closeContextMenuCallback) === null || _a === void 0 ? void 0 : _a(); });
        };
        _this.onScroll = function (event) {
            var dialogsWithUpdatedTops = [];
            var updated = false;
            _this.state.openDialogs.forEach(function (dialog) {
                var top = dialog.top;
                if (window.pageYOffset < dialog.top) { // note: must use pageYOffset not scrollY for IE
                    top = window.pageYOffset;
                    updated = true;
                }
                dialogsWithUpdatedTops.push(__assign(__assign({}, dialog), { top: top }));
            });
            if (updated) {
                _this.setState({ openDialogs: dialogsWithUpdatedTops });
            }
        };
        _this.registerBeforeUnload = function (beforeUnload) {
            _this.beforeUnloadCallbacks.push(beforeUnload);
            return function () { return _this.beforeUnloadCallbacks.splice(_this.beforeUnloadCallbacks.indexOf(beforeUnload), 1); };
        };
        _this.onBeforeUnload = function (event) {
            for (var i = 0; i < _this.beforeUnloadCallbacks.length; i++) {
                var beforeUnload = _this.beforeUnloadCallbacks[i];
                if (beforeUnload()) {
                    var message = "There are unsaved changes.";
                    (event || window.event).returnValue = message;
                    return message;
                }
            }
        };
        _this.flashMessage = function (message) {
            _this.setState(function (prevState) {
                var prevFlashMessages = prevState.flashMessages;
                var updatedFlashMessages = arrayExtensions_1.clone(prevFlashMessages);
                updatedFlashMessages.push({
                    key: "flash-" + idGenerator_1.GenerateId(),
                    message: message
                });
                return { flashMessages: updatedFlashMessages };
            });
        };
        _this.onFlashMessageWillEnter = function (flashMessage) {
            return { opacity: 1 };
        };
        _this.onFlashMessageDidEnter = function (flashMessage, element) {
            var delayUntilFadeOut = 1000;
            window.setTimeout(function () {
                _this.setState(function (prevState) {
                    var updatedFlashMessages = arrayExtensions_1.remove(prevState.flashMessages, flashMessage);
                    return { flashMessages: updatedFlashMessages };
                });
            }, delayUntilFadeOut);
            return { opacity: 1 };
        };
        _this.onFlashMessageWillExit = function (flashMessage, element) {
            return { opacity: new animation_1.DurationAnimationDefinition(1, 0, 3000) };
        };
        _this.renderFlashMessage = function (flashMessage, currentStyle) {
            return ReactDOM.createPortal(React.createElement("div", { className: "flash-notification", style: currentStyle, key: flashMessage.key }, flashMessage.message), document.getElementById("flash-notification-container"));
        };
        _this.openConfirmation = function (options) {
            return new es6_promise_1.Promise(function (resolve, reject) {
                _this.openDialog(function (closeDialog) {
                    var mergedOptions = confirmation_1.mergeWithDefaultOptions(options);
                    var onConfirm = function () { resolve(true); closeDialog(); };
                    var onCancel = function () { resolve(false); closeDialog(); };
                    return React.createElement("div", { className: "l-dialog-container", style: { width: "52em" } },
                        React.createElement("div", { className: "l-popup", style: { position: "relative", display: "block", width: "100%" } },
                            React.createElement(confirmation_1.Confirmation, { typeClassName: mergedOptions.typeClassName, title: mergedOptions.title || "", message: mergedOptions.message || "", secondaryMessage: mergedOptions.secondaryMessage || "", yesCaption: mergedOptions.yesCaption || "", noCaption: mergedOptions.noCaption, onConfirm: onConfirm, onCancel: onCancel })));
                });
            });
        };
        _this.setSerialOperationState = function (state) {
            _this.setState({
                serialOperationState: state
            });
        };
        _this.startSerialOperation = serialOperation_1.buildSerialOperationStarter(function () { return _this.state.serialOperationState; }, _this.setSerialOperationState);
        _this.setWindowLocationHref = setWindowLocationHref_1.buildSetWindowLocationHrefCallback(_this.startSerialOperation);
        _this.state = {
            openDialogs: [],
            currentContextMenu: null,
            flashMessages: [],
            serialOperationState: {
                isOperationPending: false,
                feedbackType: serialOperation_1.FeedbackType.None
            }
        };
        return _this;
    }
    App.prototype.hasZIndex = function (zIndex) {
        return !!zIndex;
    };
    App.prototype.componentDidMount = function () {
        document.addEventListener("click", this.onClick);
        document.addEventListener("scroll", this.onScroll);
        window.addEventListener("beforeunload", this.onBeforeUnload);
    };
    App.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.onClick);
        document.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("beforeunload", this.onBeforeUnload);
    };
    App.prototype.render = function () {
        var renderedChildren = this.props.renderChildren(this.openDialog, this.registerContextMenu, this.registerBeforeUnload, this.flashMessage, this.openConfirmation, this.startSerialOperation, this.setWindowLocationHref);
        var dialogStack = React.createElement(transitionGroup_1.TransitionGroup, { data: this.state.openDialogs, willEnter: this.onDialogWillEnter, didEnter: this.onDialogDidEnter, doneEntering: this.onDialogDoneEntering, willExit: this.onDialogWillExit, renderChild: this.renderDialog });
        var contextMenuTransitionGroup = React.createElement(transitionGroup_1.TransitionGroup, { data: this.state.currentContextMenu ? [this.state.currentContextMenu] : [], willEnter: this.onContextMenuWillEnter, didEnter: this.onContextMenuDidEnter, doneEntering: this.onContextMenuDoneEntering, willExit: this.onContextMenuWillExit, renderChild: this.renderContextMenu });
        var flashMessagesStack = React.createElement(transitionGroup_1.TransitionGroup, { data: this.state.flashMessages, willEnter: this.onFlashMessageWillEnter, didEnter: this.onFlashMessageDidEnter, willExit: this.onFlashMessageWillExit, renderChild: this.renderFlashMessage });
        var serialOperation = React.createElement(serialOperation_1.SerialOperation, { portalId: "loading-banner", state: this.state.serialOperationState });
        return React.createElement(React.Fragment, null,
            renderedChildren,
            dialogStack,
            contextMenuTransitionGroup,
            flashMessagesStack,
            serialOperation);
    };
    return App;
}(React.Component));
exports.App = App;
